import { render, staticRenderFns } from "./NewDialogTriggerBtn.vue?vue&type=template&id=33207b34&scoped=true&"
import script from "./NewDialogTriggerBtn.vue?vue&type=script&lang=js&"
export * from "./NewDialogTriggerBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33207b34",
  null
  
)

export default component.exports